const _ = require("lodash");
const channels = require("./app__channels").channels;
const facebook = _.find(channels, { channel_short_name: "facebook" });
const instagram = _.find(channels, { channel_short_name: "instagram" });

module.exports = [
  {
    budget: 400,
    minClicks: 200,
    name: "Social Media Booster S",
    id: "aws--small-facebook-instagram-s-members",
    nameShort: "S",
    description: "Facebook & Instagram / 200 qualifizierte Klicks / 30 Tage Laufzeit",
    color: "#B0D59D",
    selectedChannels: [facebook, instagram]
  },
  {
    budget: 600,
    minClicks: 300,
    name: "Social Media Booster M",
    id: "aws--small-facebook-instagram-m-members",
    nameShort: "M",
    description: "Facebook & Instagram / 300 qualifizierte Klicks / 30 Tage Laufzeit",
    color: "#B0D59D",
    selectedChannels: [facebook, instagram]
  }
];
